
export class UserPasswordModel {
    user: string;
    isChangeRequest: boolean;
    
    constructor(userName: string) {
        this.user = userName;
    }
}